'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthorHeader = undefined;

var _themeProvider = require('@spp/theme-provider');

var _AuthorHeader = require('./AuthorHeader');

var _AuthorHeader2 = _interopRequireDefault(_AuthorHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.AuthorHeader = _AuthorHeader2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-author-header')(_AuthorHeader2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-author-header/lib/cjs/index.js
 ** module id = 570
 ** module chunks = 1
 **/